import { useEffect, useState } from 'react'
import { FacultyType, MajorType, StudentType } from '../../Utils/DataType'
import logo from '../../images/LOGO_FIT.png'
import InputValidate from '../../components/InputValidate'
import AddressSelect from '../../components/AddressSelect'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import UtilFunctions from '../../Utils/UtilFucntion'
import AxiosClient from '../../api/AxiosClient'
const initForm: StudentType = {
    student_id: '',
    first_name: '',
    last_name: '',
    email: '',
    gender: 'Nam',
    birthday: '2001-01-01',
    address: '',
    phone: '',
    major_id: -1,
    faculty_id: -1,
    password: ''
}

const initValidForm = {
    student_id: false,
    first_name: false,
    last_name: false,
    email: false,
    gender: false,
    birthday: false,
    address: false,
    phone: false,
    major_id: false,
    faculty_id: false
}

type props = {
    setIsLogin: Function
}
export default function Register({ setIsLogin }: props) {
    const [dataForm, setDataForm] = useState<StudentType>(initForm);
    const [validForm, setValidForm] = useState<any>(initValidForm);
    const [listFaculty, setListFacculty] = useState<FacultyType[]>([]);
    const [listMajor, setListMajor] = useState<MajorType[]>([]);

    function onChangeData(name: string, value: string): void {
        setDataForm({ ...dataForm, [name]: value })
    }

    function setAddress(address: string): void {
        setDataForm({ ...dataForm, address: address });
    }
    function onChangeGender(event: SelectChangeEvent<string>): void {
        setDataForm({ ...dataForm, gender: event.target.value });
    }

    function onChangeFaculty(event: SelectChangeEvent<number>): void {
        let temp = `${event.target.value}`
        setDataForm({ ...dataForm, faculty_id: parseInt(temp) });
    }

    function onChangeMajor(event: SelectChangeEvent<number>): void {
        let temp = `${event.target.value}`
        setDataForm({ ...dataForm, major_id: parseInt(temp) });
    }

    //Get list faculty_id
    function fetchFaculty(): void {
        AxiosClient.get('faculties').then((data) => {
            setListFacculty(data.data.data);
        })
    }

    function fetchMajor(id: number): void {
        AxiosClient.get(`majors`).then((data) => {
            let list: MajorType[] = data.data.data;
            list = list.filter((item) => `${item.faculty_id }`=== `${id}`);
            setListMajor(list);
            console.log(list);
        })
    }

    useEffect(() => {
        fetchFaculty();
    }, [])

    useEffect(() => {
        setDataForm({ ...dataForm, major_id: -1 });
        setListMajor([]);
        fetchMajor(dataForm.faculty_id);
    }, [dataForm.faculty_id]);

    useEffect(() => {
        setValidForm({
            student_id: dataForm.student_id.length >= 10,
            first_name: dataForm.first_name.length > 0,
            last_name: dataForm.last_name.length > 0,
            email: UtilFunctions.isValidEmail(dataForm.email),
            gender: true,
            birthday: true,
            address: true,
            phone: UtilFunctions.isValidPhone(dataForm.phone),
            major_id: dataForm.major_id > -1,
            faculty_id: dataForm.faculty_id > -1
        })
    }, [dataForm]);

    function isValidForm(): boolean {
        let keys = Object.keys(validForm);
        for (let key of keys) {
            if (!validForm[key]) return false;
        }
        return true;
    }

    function onSubmit(): void {
        AxiosClient.post('register', dataForm).then((data) => {
            UtilFunctions.showToastSuccess('Đăng ký thành công!');
            setTimeout(() => {
                window.location.href = '/login';
            }, 1000);
        }).catch((e) => {
            UtilFunctions.showToastSuccess('Đã có lỗi xảy ra!');
        })
    }

    return (
        <div className="register-form">
            <div className="login-title">
                <div className="login-title--title">Đăng ký</div>
                <div className="login-title--description">Đăng ký thông tin để được cấp tài khoản</div>
            </div>
            <div className="form-main mt-8">
                <div className="grid grid-rows-1 grid-cols-2 gap-8">
                    <InputValidate label={'Họ lót'} name={'last_name'} onChangeData={onChangeData} value={dataForm.last_name} isValid={validForm.last_name} alert={'Vui lòng không để trống'} disabled={false} placeholder={'Họ lót'} type={'text'}></InputValidate>
                    <InputValidate label={'Tên'} name={'first_name'} onChangeData={onChangeData} value={dataForm.first_name} isValid={validForm.first_name} alert={'Vui lòng không để trống'} disabled={false} placeholder={'Tên'} type={'text'}></InputValidate>
                </div>
                <div className="grid grid-rows-1 grid-cols-2 gap-8 mt-4">
                    <InputValidate label={'Email'} name={'email'} onChangeData={onChangeData} value={dataForm.email} isValid={validForm.email} alert={'Vui lòng nhập đúng định dạng'} disabled={false} placeholder={'Email'} type={'text'}></InputValidate>
                    <InputValidate label={'Số điện thoại'} name={'phone'} onChangeData={onChangeData} value={dataForm.phone} isValid={validForm.phone} alert={'Vui lòng nhập đúng định dạng'} disabled={false} placeholder={'Số điện thoại'} type={'text'}></InputValidate>
                </div>
                <div className="mt-4">
                    <div className="field-title font-medium text-[#616161] mb-2">Địa chỉ</div>
                    <AddressSelect textAddress='Hà Nội-Ba Vì-Ba Trại' setAddress={setAddress} />
                </div>
                <div className="grid grid-rows-1 grid-cols-2 gap-8 mt-4">
                    <div className='w-full'>
                        <div className="font-medium text-[#616161] mb-2">Ngày sinh</div>
                        <div className="h-10 overflow-hidden ">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker className="date-picker" format="DD/MM/YYYY" value={dayjs(dataForm.birthday)} onChange={() => setDataForm({ ...dataForm, birthday: dayjs(dataForm.birthday).format('YYYY-MM-DD') })} />
                            </LocalizationProvider>
                        </div>
                    </div>
                    <div className="font-medium text-[#616161] w-full">
                        <div className="mb-2">
                            Giới tính
                        </div>
                        <Select value={dataForm.gender} size="small" onChange={onChangeGender} fullWidth>
                            <MenuItem value={'Nam'}>Nam</MenuItem>
                            <MenuItem value={'Nữ'}>Nữ</MenuItem>
                        </Select>
                    </div>
                </div>
                <div className="grid grid-rows-1 grid-cols-3 mt-6 gap-8">
                    <InputValidate label={'Mã SV'} name={'student_id'} onChangeData={onChangeData} value={dataForm.student_id} isValid={UtilFunctions.isValidPassword(dataForm.student_id)} alert={'MSSV chưa hợp lệ'} disabled={false} placeholder={'Mã số sinh viên'} type={'text'} />
                    <div className="font-medium text-[#616161] w-full">
                        <div className="input-valid__label">
                            <label htmlFor="">Khoa</label>
                        </div>
                        <Select value={dataForm.faculty_id} size="small" fullWidth onChange={onChangeFaculty}>
                            <MenuItem value={-1}>Chọn</MenuItem>
                            {listFaculty.length && listFaculty.map((item, index) => <MenuItem key={index} value={item.id}>{item.name}</MenuItem>)}
                        </Select>
                    </div>
                    <div className="font-medium text-[#616161] w-full">
                        <div className="input-valid__label">
                            <label htmlFor="">Ngành</label>
                        </div>
                        <Select value={dataForm.major_id} size="small" fullWidth onChange={onChangeMajor}>
                            <MenuItem value={-1}>Chọn</MenuItem>
                            {listMajor.length && listMajor.map((item, index) => <MenuItem value={item.id}>{item.name}</MenuItem>)}
                        </Select>
                    </div>
                </div>
                <div className="form-action grid grid-cols-3 mt-8 items-end gap-8">
                    <InputValidate label={'Mật khẩu'} name={'password'} onChangeData={onChangeData} value={dataForm.password} isValid={UtilFunctions.isValidPassword(dataForm.password)} alert={'Mật khẩu chưa hợp lệ'} disabled={false} placeholder={'Password'} type={'text'} />
                    <Button variant='contained' style={{ height: '2.5rem' }} disabled={!isValidForm()} onClick={onSubmit}>Đăng ký</Button>
                    <div className='text-sm font-medium'>Nếu đã có tài khoản, vui lòng <span className='font-bold cursor-pointer text-[#01579b]' onClick={() => setIsLogin(true)}>đăng nhập</span></div>
                </div>
            </div>
        </div>
    )
}